module.exports = __webpack_public_path__ + "img/mission.80c3349c.webp";